import * as React from "react"
import { bool, string, array, shape, oneOfType, number, func } from "prop-types"
import { Alert, Box, Button, StackView } from "@planningcenter/tapestry-react"
import Icon from "components/planning_center_icon"
import TimeRange from "components/ui/TimeRange"
import DatePicker from "components/ui/DatePicker"
import { momentDateTime } from "utils/dates"

const EditSessions = ({
  removeAppEventSession,
  sessions,
  showInfoAlert,
  updateAppEventSession
}) => {
  return (
    <>
      {showInfoAlert && (
        <Alert type="info" marginBottom={1} boxShadow="none" fontSize="14px">
          <Box>
            Sessions are the dates and times when your event will be available on Check-Ins
            stations. We&apos;ve added the first five based on your event date/times, but you can
            adjust them or add more sessions as needed.
          </Box>
        </Alert>
      )}
      {sessions.map(session => (
        <EditSession
          key={`edit-sessions-${session.id}`}
          removeAppEventSession={removeAppEventSession}
          session={session}
          sessionsCount={sessions.length}
          updateAppEventSession={updateAppEventSession}
        />
      ))}
    </>
  )
}

EditSessions.propTypes = {
  removeAppEventSession: func,
  showInfoAlert: bool,
  sessions: array,
  updateAppEventSession: func
}

const EditSession = ({ removeAppEventSession, session, sessionsCount, updateAppEventSession }) => {
  const handleDateChange = (id, datetime) => {
    updateAppEventSession(id, {
      showsAt: momentDateTime(datetime, session.showsAt).format(),
      hidesAt: momentDateTime(datetime, session.hidesAt).format()
    })
  }

  return (
    <StackView axis="horizontal" spacing={1} marginBottom={1}>
      <Box flex="2">
        <DatePicker
          datetime={session.showsAt}
          onChange={datetime => handleDateChange(session.id, datetime)}
        />
      </Box>
      <Box flex="2">
        <TimeRange
          startsAt={session.showsAt}
          endsAt={session.hidesAt}
          onChangeStartsAt={datetime => updateAppEventSession(session.id, { showsAt: datetime })}
          onChangeEndsAt={datetime => updateAppEventSession(session.id, { hidesAt: datetime })}
          twentyFourHourTime={App.currentOrganization.twentyFourHourTime}
        />
      </Box>

      {sessionsCount > 1 && (
        <Button
          onClick={() => removeAppEventSession(session.id)}
          variant="naked"
          theme="destroy"
          aria-label="remove label"
          alignSelf="stretch"
          paddingHorizontal={0.5}
        >
          <Icon symbol="general#x" />
        </Button>
      )}
    </StackView>
  )
}

EditSession.propTypes = {
  removeAppEventSession: func.isRequired,
  session: shape({
    id: oneOfType([string, number]).isRequired,
    showsAt: oneOfType([string, number]).isRequired,
    hidesAt: oneOfType([string, number]).isRequired
  }).isRequired,
  sessionsCount: number,
  updateAppEventSession: func
}

export default EditSessions
